import Marquee from "react-fast-marquee";

const ITEMS = ["Voltage Stabilizers", "Solar Power", "Inverter & Battery", "Water Coolers", "Servo Control", "Since 1986"];

export const MarqueeStrip = () => (
  <div className="border-y border-white/10 bg-void py-6 overflow-hidden" data-testid="marquee">
    <Marquee speed={45} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <div key={i} className="flex items-center">
          <span className="font-head font-black uppercase text-5xl md:text-7xl tracking-tight text-stroke px-8">
            {t}
          </span>
          <span className="w-3 h-3 rotate-45 bg-forge" />
        </div>
      ))}
    </Marquee>
  </div>
);
